<div class="insight-panel-parent">
  <div class="insight-panel-body">
      <!--TODO this sample data will be removed after the backend data binding -->
      <p>This is the panel test</p>
  </div>
</div>